import React, { useEffect, useContext, useState } from "react"
import { clBasic, Scrudo, codiguera, sizeFiltros, lunesSemana, HOY } from "./general";
import { AppContext } from "./index";
import filtroIcon from "./img/filtro.png";
import CerrarVentana from "./CerrarVentana"
import ListaOpciones from "./ListaOpciones";

export default function UtilizacionGlobal() {

    let { firebase } = useContext(AppContext);
    let color = ["#DF7401", "#80FF00"];
    const listaSemanas = { "4 semanas": 4, "5 semanas": 5, "6 semanas": 6, "7 semanas": 7, "8 semanas": 8, "6 meses": 30 }

    let h = window.innerHeight * 0.77
    let w = window.innerWidth * 0.82

    const [prioridadIncidentes, setPrioridadIncidentes] = useState("Todos");
    const [prioridadProyectos, setPrioridadProyectos] = useState("Todos");
    const [persona, setPersona] = useState("Todas");
    const [semanas, setSemanas] = useState(6);
    const [filtros, setFiltros] = useState(false);

    let horasDisponibles = persona !== "Todas" ? firebase.usuario(persona).horassemana : firebase.totalHorasDisponibles

    const maximo = () => {  // devuelve el maximo de un objeto
        let max = 0
        for (let x = 0; x < semanas; x++) {
            let aux = firebase.totalHorasProyectos[x] + firebase.totalHorasIncidentes[x]
            if (aux > max) max = aux;
        }
        if (horasDisponibles > max) max = horasDisponibles
        return max
    }

    useEffect(() => {
        firebase.horasIncurridas(lunesSemana(HOY, semanas), HOY, prioridadIncidentes, prioridadProyectos, persona)
    }, [firebase, semanas, prioridadProyectos, prioridadIncidentes, persona]);

    useEffect(() => { // carga del canvas
        let c = document.getElementById("UTgrafico").getContext("2d");
        c.clearRect(0, 0, w + 20, h)

        const lmax = h * 0.75;
        const ybase = h - 100;
        const anchoBarra = w / (semanas * 2 - 1);
        const xinicial = 10;
        const etiquetas = ["Proyectos", "Incidentes"];

        // referencias
        let coordXRef = [xinicial + w / 2 - 100, xinicial + w / 2 + 100]
        for (let i = 0; i < etiquetas.length; i++) {
            c.beginPath()
            c.fillStyle = color[i];
            c.fillRect(coordXRef[i], ybase + 40, 45, 20);
            c.font = "2vh Arial";
            c.fillStyle = clBasic;
            c.fillText(etiquetas[i], coordXRef[i] + 50, ybase + 60);
        }

        // barras
        c.beginPath();
        c.lineWidth = anchoBarra;
        let xi = xinicial + anchoBarra / 2;
        for (let m = 0; m < semanas; m++) {
            let yproyecto = firebase.totalHorasProyectos[m] * lmax / maximo()
            let yincidente = firebase.totalHorasIncidentes[m] * lmax / maximo()
            c.beginPath();
            c.moveTo(xi, ybase);
            c.lineTo(xi, ybase - yproyecto);
            c.strokeStyle = color[0];
            c.stroke();
            c.beginPath();
            c.moveTo(xi, ybase - yproyecto);
            c.lineTo(xi, ybase - yproyecto - yincidente);
            c.strokeStyle = color[1];
            c.stroke();

            // etiquetas
            c.font = "700 2vh Arial";
            c.fillStyle = clBasic;
            c.fillText("S" + m, xi - 10, ybase + 20);
            //c.fillText(firebase.totalHorasProyectos[m] + firebase.totalHorasIncidentes[m], xi - 10, ybase - yproyecto - yincidente - 20);
            // porcentajes
            if (firebase.totalHorasProyectos[m]) {
                c.fillText(Math.trunc(firebase.totalHorasProyectos[m] * 100 / horasDisponibles).toString() + "%", xi - 15, ybase - yproyecto / 2);
            }
            if (firebase.totalHorasIncidentes[m]) {
                c.fillText(Math.trunc(firebase.totalHorasIncidentes[m] * 100 / horasDisponibles).toString() + "%", xi - 15, ybase - yproyecto - yincidente / 2);
            }
            xi = xi + anchoBarra * 2;
        }

        // linea de horas Disponibles
        c.beginPath();
        c.lineWidth = 2;
        c.moveTo(0, ybase - (horasDisponibles * lmax) / maximo());
        c.lineTo(anchoBarra * (semanas * 2 - 1) + 20, ybase - (horasDisponibles * lmax) / maximo());
        c.setLineDash([2, 2]);
        c.strokeStyle = clBasic;
        c.stroke();
        let hd = "Horas disponibles: " + horasDisponibles.toString()
        c.fillText(hd, anchoBarra * (semanas * 2 - 1) - c.measureText(hd).width, ybase - horasDisponibles * lmax / maximo() - 5);
    });


    function FiltroProyectos() {
        const Sfiltros = {
            position: "relative",
            background: "white",
            padding: "10px",
            border: "1px solid white",
            borderRadius: "5px",
            fontSize: sizeFiltros,
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            color: clBasic,
        };
        const Sfiltro = {
            display: "flex",
            flexDirection: "row",
            marginTop: "3px",
        };
        const Setiqueta = {
            width: "9vw",
            fontWeight: 500,
            padding: "3px",
        };
        const Sinput = {
            padding: "3px",
            background: "#F2F2F2",
            width: "5vw",
            textAlign: "center",
            cursor: "pointer",
            borderRadius: "5px",

        };

        return (
            <div style={Sfiltros} >
                <CerrarVentana set={setFiltros} />
                <div style={Sfiltro}>
                    <div style={Setiqueta}>Prioridad incidentes:</div>
                    <div id="UTincprior" style={Sinput}>
                        {prioridadIncidentes}
                    </div>
                </div>
                <div style={Sfiltro}>
                    <div style={Setiqueta}>Prioridad proyectos:</div>
                    <div id="UTproyprior" style={Sinput}>
                        {prioridadProyectos}
                    </div>
                </div>
                <div style={Sfiltro}>
                    <div style={Setiqueta}>Cant. semanas:</div>
                    <div id="UTsemana" style={Sinput}>
                        {semanas}
                    </div>
                </div>
                <div style={Sfiltro}>
                    <div style={Setiqueta}>Persona:</div>
                    <div id="UTpersona" style={Sinput}>
                        {persona}
                    </div>
                </div>
                <ListaOpciones setFiltro={setPrioridadIncidentes} lista={codiguera["prioridad"]} elemento="UTincprior" titulo={"Prioridades incidentes"} />
                <ListaOpciones setFiltro={setPrioridadProyectos} lista={codiguera["prioridad"]} elemento="UTproyprior" titulo={"Prioridades proyectos"} />
                <ListaOpciones setFiltro={setSemanas} lista={listaSemanas} elemento="UTsemana" titulo={"Cantidad de semanas"} />
                <ListaOpciones setFiltro={setPersona} lista={firebase.filtroPersonas} elemento="UTpersona" titulo={"Persona"} />
            </div >
        );
    }

    return (
        <div style={{ ...Scrudo, width: "100%", margin: "20px" }}>

            <div style={{ position: "absolute", top: "13vh", left: "9vw", zIndex: 8 }}>
                {!filtros && (
                    <img
                        src={filtroIcon}
                        alt="?"
                        height="15px"
                        width="15px"
                        style={{ cursor: "pointer", background: "black" }}
                        onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                        onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.1)}
                        onClick={(e) => {
                            e.currentTarget.style.opacity = 0.1;
                            setFiltros(true);
                        }}
                    ></img>
                )}
                {filtros && <FiltroProyectos />}
            </div>

            <div>
                <div style={Scanvas}>
                    <canvas id="UTgrafico" height={h.toString() + "px"} width={(w + 20).toString() + "px"} />
                </div>
            </div>
        </div>
    );
}

const Scanvas = {
    position: "relative",
    display: "flex",
    justifyContent: "center"
};
